import { MARKETING } from 'self-service-api/constants/ProductLines';
import { useAppSelector } from '../../../reducers';
import { productForSkuIdSelector } from '../../../selectors/ProductsSelectors';
const useMarketingProduct = productConfigurations => {
  return useAppSelector(state => {
    const marketingProduct = productConfigurations.find(productConfig => {
      const hubProduct = productForSkuIdSelector(state, {
        skuId: productConfig.skuId
      });
      return hubProduct.productLine === MARKETING;
    });
    return marketingProduct ? productForSkuIdSelector(state, {
      skuId: marketingProduct.skuId
    }) : undefined;
  });
};
export default useMarketingProduct;